var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.5001H2C1.44772 23.5001 1 23.0524 1 22.5001V1.50012C1 0.947837 1.44772 0.500122 2 0.500122H23C23.5523 0.500122 24 0.947837 24 1.50012V22.5001C24 23.0524 23.5523 23.5001 23 23.5001H17V14.5001H19.559C19.8126 14.5021 20.0276 14.3138 20.059 14.0621L20.434 11.0621C20.4519 10.9191 20.4072 10.7754 20.3114 10.6678C20.2156 10.5601 20.0781 10.499 19.934 10.5001H17V9.18512C17.0011 8.25459 17.7555 7.50067 18.686 7.50012H20.5C20.7761 7.50012 21 7.27626 21 7.00012V4.00012C21 3.72398 20.7761 3.50012 20.5 3.50012H18.686C15.5475 3.50343 13.0039 6.04659 13 9.18512V10.5001H10.5C10.2239 10.5001 10 10.724 10 11.0001V14.0001C10 14.2763 10.2239 14.5001 10.5 14.5001H13V23.5001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e688244dea249ec93041e67f26fca123.svg";
export { ForwardRef as ReactComponent };